module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "booksection"
  }, [_c('p', {
    staticClass: "chap1"
  }, [_vm._v("ADMONITION")]), _vm._v(" "), _c('p', {
    staticClass: "chap_line"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("I")]), _vm._v("t is a fact of life that sin will haunt you if you are here in the mortal condition")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Which is exactly why the prophets, both new and old, have warned us of the consequences of sin’s one-way ride to perdition with clear words of admonition.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("The still voice that can speak to those that choose to hear and obey those sweet precious words of counsel and redemption’s harking")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Is thunder rolling through their souls so strong that they can see the light of Christ’s love shine around them that it banishes Satan’s harpies.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("to God the Father is for us the perfect conduit for holy edification")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("As we learn to be more Christ-like in every facet of our lives, we understand the need for endless erudition.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("It is a fact of life that sin will haunt you if you are here in the mortal condition")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Which is exactly why the prophets, both new and old, have warned us of the consequences of sin’s one-way ride to perdition with clear words of admonition.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70b87adf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap005.vue
// module id = 81
// module chunks = 0